var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 27.4125C9.2798 27.4125 3.7998 22.2875 3.7998 15.975V13.625C3.7998 13.1375 4.22647 12.75 4.73314 12.75C5.2398 12.75 5.66647 13.15 5.66647 13.625V15.975C5.66647 21.3125 10.2931 25.65 15.9865 25.65C21.6798 25.65 26.3065 21.3125 26.3065 15.975V13.625C26.3065 13.1375 26.7331 12.75 27.2398 12.75C27.7465 12.75 28.1731 13.15 28.1731 13.625V15.975C28.1998 22.2875 22.7198 27.4125 15.9998 27.4125Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 2.5C11.5195 2.5 7.86621 5.925 7.86621 10.125V15.9875C7.86621 20.1875 11.5195 23.6125 15.9995 23.6125C20.4795 23.6125 24.1329 20.1875 24.1329 15.9875V10.125C24.1329 5.925 20.4795 2.5 15.9995 2.5ZM18.9062 13.2375C18.8129 13.575 18.4795 13.8 18.1195 13.8C18.0529 13.8 17.9729 13.7875 17.9062 13.775C16.5462 13.425 15.1062 13.425 13.7462 13.775C13.3062 13.8875 12.8662 13.65 12.7462 13.2375C12.6262 12.8375 12.8795 12.4125 13.3195 12.3C14.9595 11.875 16.6929 11.875 18.3329 12.3C18.7729 12.4125 19.0262 12.825 18.9062 13.2375ZM20.0395 9.775C19.9195 10.0875 19.6129 10.275 19.2795 10.275C19.1862 10.275 19.0929 10.2625 18.9995 10.225C16.9595 9.525 14.7195 9.525 12.6795 10.225C12.2529 10.375 11.7862 10.175 11.6262 9.775C11.4795 9.3875 11.6929 8.95 12.1195 8.8C14.5195 7.9875 17.1595 7.9875 19.5462 8.8C19.9729 8.95 20.1862 9.3875 20.0395 9.775Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.e727a14f97b79be27b278230ed116d85.svg";
export { ForwardRef as ReactComponent };